export interface ConsentCategories {
  essential: true
  analytics: boolean
  marketing: boolean
}

export interface ConsentState {
  categories: ConsentCategories
  timestamp: string
  version: number
}

export interface ConsentContextValue {
  consent: ConsentState | null
  hasConsented: boolean
  isAnalyticsAllowed: boolean
  isMarketingAllowed: boolean
  acceptAll: () => void
  rejectNonEssential: () => void
  updateConsent: (categories: Partial<Omit<ConsentCategories, 'essential'>>) => void
  openPreferences: () => void
}

export const CONSENT_VERSION = 1
